import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../services/data.service';
import {LoadingService} from '../../services/loading/loading.service';
import {SsoService} from '../sso/sso.service';


@Component({
    selector: 'app-login-validate',
    templateUrl: './login-validate.component.html',
    styleUrls: ['./login-validate.component.css'],
    standalone: false
})
export class LoginValidateComponent implements OnInit {
    public redirectUrl: string;
    loading = false;
    errorMessage: string;
    ssoInitResult: string;
    returnUrl: string;
    internal: boolean;
    host: string;
    private tmssloader;

    constructor(private ssoService: SsoService,
                private router: Router,
                private route: ActivatedRoute,
                private dataService: DataService,
                private loader: LoadingService) {
        this.tmssloader = loader;
    }
    ngOnInit() {
        this.loginSSO();
    }

    loginSSO() {
        // reset login status
        sessionStorage.clear();
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.tmssloader.show();
        setTimeout(() => {
            this.ssoService.getHostDetails().subscribe(
                hostDetails => {
                    this.host = hostDetails.host;
                    this.dataService.setHost(hostDetails.host);
                    console.log('Host : ' + hostDetails.host);
                    if ((this.host === 'localhost' || this.host === 'tmss.dev-acqit.helix.gsa.gov' ||
                        this.host === 'tmss.test-acqit.helix.gsa.gov' || this.host === 'tmss.prod-acqit.helix.gsa.gov' ||
                        this.host === 'tmss.preprod-acqit.helix.gsa.gov' || this.host === 'tmss.gsa.gov' ||
                        this.host === 'tmss-dev.gsa.gov' ) &&
                        (null != hostDetails.internal && hostDetails.internal === '1')) {
                        this.internal = true;
                        // Initiate SSO only if the request comes from internal GSA network.
                        this.ssoService.initiateSSO()
                            .subscribe(
                                ssoInitResult => {
                                    this.ssoInitResult = ssoInitResult;
                                    console.log('sso Url ' + this.ssoInitResult);
                                    // this will retrun a secure auth url from server
                                    this.redirectUrl = this.ssoInitResult;
                                    if (this.redirectUrl) {
                                        window.location.href = this.redirectUrl;
                                    }
                                }, (error) => {
                                    this.loading = false;
                                    this.tmssloader.hide();
                                }, () => {
                                    this.tmssloader.hide();
                                });
                    } else {
                        this.internal = false;
                        // redirecting to the home page
                        this.redirectUrl = '/signon';
                        this.router.navigate([this.redirectUrl]);
                    }
                    this.tmssloader.hide();
                },
                error => {
                    this.internal = false;
                    // redirecting to the home page
                    this.redirectUrl = '/home';
                    this.router.navigate([this.redirectUrl]);
                    this.errorMessage = <any>error;
                    this.tmssloader.hide();
                }, () => {
                    this.tmssloader.hide();
                });
        }, 2000);
    }

}
